"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createModelProvider = void 0;
const traverse_model_values_1 = __importDefault(require("../utils/traverse-model-values"));
const selectors_1 = require("../modules/selectors");
const render_to_xml_1 = __importDefault(require("../utils/render-to-xml"));
const composure_1 = require("@icg360/composure");
const createModelProvider = (state, options) => (modelId) => {
    const form = (0, selectors_1.useFormOrCurrent)(state, { useForm: options });
    if (state.rex.version[form.id] > 1) {
        if (options.type === 'XML') {
            return formModelXML(state, form.id, !modelId || modelId === 'commit', options.onlyChanged);
        }
        return formModelJSON(state, form.id, !modelId || modelId === 'default');
    }
    const model = state.rex.models[form.id][form.index];
    if (!model)
        return {};
    return options.type === 'JSON'
        ? (0, traverse_model_values_1.default)({ model, modelId, options })
        : (0, render_to_xml_1.default)({
            model,
            modelId,
            onlyChanged: options.onlyChanged,
        });
};
exports.createModelProvider = createModelProvider;
function formModelJSON(state, modelKey, isDefault) {
    const values = {};
    const invalidModels = [];
    const changed = [];
    (0, composure_1.eachTerm)(state.rex.formModel, modelKey, (key, termState, term) => {
        if (isDefault && (term.sync === 'none' || term.sync === 'pull'))
            return;
        if (!termState) {
            // This doesn't tell the whole story,
            // we might lose an interable instance but not count them as changed
            values[key] = term.default || '';
            return;
        }
        values[key] = termState.value;
        if (termState.isRelevant &&
            termState.isValid === false &&
            termState.validation.some((v) => !v.pass && v.type !== 'enum-option')) {
            invalidModels.push(key);
        }
        if (termState.value !== termState.initial) {
            changed.push(key);
        }
    });
    return {
        values,
        isValid: invalidModels.length === 0,
        invalidModels,
        changed,
    };
}
function formModelXML(state, modelKey, isCommit, onlyChanged = false) {
    let submitDetails = state.rex.composure[modelKey].submissions.submit;
    if (!isCommit && state.rex.composure[modelKey].submissions.preview) {
        submitDetails = state.rex.composure[modelKey].submissions.preview;
    }
    if (!submitDetails)
        return '';
    const { changed, values } = formModelJSON(state, modelKey, true);
    const data = onlyChanged
        ? changed.map((key) => [key, values[key]])
        : Object.entries(values);
    if (submitDetails.type === 'transaction-request') {
        return getTRTemplate(submitDetails.requestType, data);
    }
    if (submitDetails.type === 'policy-request') {
        return `<PolicyRequest locationid="" percentagecomplete="" producercode="" useragent="" username="">
  <flags />
  <basecriteria>
    <Carrier />
    <Product />
    <EffectiveDateRange />
  </basecriteria>
  ${mapDataItems(data, '  ')}
</PolicyRequest>`;
    }
    return '';
}
const COMMON_TR_ELEMENTS = `<Initiation>
    <Initiator type="user" />
  </Initiation>
  <Target>
    <Identifiers>
      <Identifier name="InsightPolicyId" value="" />
    </Identifiers>
    <SourceVersion />
  </Target>`;
function getTRTemplate(type, data) {
    if (type === 'RenewalPreview') {
        return `<TransactionRequest xmlns:icslocal="com.ics360.policy.data.local" schemaVersion="1.4" type="RenewalPreview">
  ${COMMON_TR_ELEMENTS}
  <RenewalChanges>
    <Set>
      ${mapDataItems(data, '      ')}
    </Set>
  </RenewalChanges>
</TransactionRequest>`;
    }
    if (type === 'ChangeAtRenewal') {
        return `<TransactionRequest schemaVersion="1.7" type="ChangeAtRenewal">
  ${COMMON_TR_ELEMENTS}
  <Comment />
  <ChangeAtRenewal>
    <PolicyTerm />
    <Set>
      ${mapDataItems(data, '      ')}
    </Set>
  </ChangeAtRenewal>
</TransactionRequest>`;
    }
    if (type === 'InsuredChanges') {
        return `<TransactionRequest xmlns:icslocal="com.ics360.policy.data.local" schemaVersion="1.4" type="InsuredChanges">
  ${COMMON_TR_ELEMENTS}
  <EffectiveDate />
  <ReasonCode />
  <Comment />
  <CustomerChanges>
    <Set>
      ${mapDataItems(data, '      ')}
    </Set>
  </CustomerChanges>
</TransactionRequest>`;
    }
    if (type === 'DocumentGeneration') {
        return `<TransactionRequest xmlns:icslocal="com.ics360.policy.data.local" schemaVersion="1.6" type="DocumentGeneration">
  ${COMMON_TR_ELEMENTS}
  <EffectiveDate />
  <Comment />
  <Documents>
    ${mapDataElements(data)}
  </Documents>
</TransactionRequest>`;
    }
    if (type === 'AgentReinstatement') {
        return `<TransactionRequest xmlns:icslocal="com.ics360.policy.data.local" schemaVersion="1.4" type="AgentReinstatement">
  ${COMMON_TR_ELEMENTS}
  <EffectiveDate />
  <ReasonCode />
  <Comment />
  <ReinstatementRequest>
    <Set>
      ${mapDataItems(data, '      ')}
    </Set>
  </ReinstatementRequest>
</TransactionRequest>`;
    }
    // Endorsement, ChangeEffectiveDate, Cancellation
    return `<TransactionRequest xmlns:icslocal="com.ics360.policy.data.local" schemaVersion="1.4" type="${type}">
  ${COMMON_TR_ELEMENTS}
  <EffectiveDate />
  <ReasonCode />
  <Comment />
  <IntervalRequest>
    <StartDate />
    ${mapDataItems(data)}
  </IntervalRequest>
</TransactionRequest>`;
}
function mapDataItems(entries, indent = '    ') {
    return entries
        .map(([key, value]) => `<DataItem name="${key}" value="${value}" />`)
        .join('\n' + indent);
}
function mapDataElements(entries, indent = '    ') {
    return entries
        .map(([key, value]) => `<${key}>${value}</${key}>`)
        .join('\n' + indent);
}
//# sourceMappingURL=create-model-provider.js.map